<template>
	<div class="xs-12 p4">
		<div class="pb2 fs3 fw7">{{ $t("file_name") }}</div>
		<div class="flex xs-12 xs-middle">
			<j-base-input-text
				class="xs"
				size="small"
				v-model="searchTerm"
				@input="testInput"
			/>
			<j-button
				:isLoading="isLoading"
				size="small"
				class="flex ml2"
				@click="fetchResults"
			>
				<crm-icon color="c5" name="search" />
			</j-button>
		</div>

		<!-- Results -->
		<div v-if="firstSearch" class="pb2 fs3 fw7 mt6">{{ $t("results") }}</div>
		<div v-if="isLoading" class="flex xs-middle xs-center p8">
			<j-spinner :delay="0" />
		</div>
		<j-card v-if="!isLoading && results.length">
			<div
				class="p2 cu2 bg5"
				:class="{ 'bb1 bc7': i < results.length + 1 }"
				v-for="(file, i) in results"
				:key="i"
				@click="selectFile(file)"
			>
				<div class="xs-12 c6 fw7 fs3 mb2">{{ file.fileName }}</div>
				<div class="xs-12 fs3">{{ file.key }}</div>
			</div>
		</j-card>

		<j-card
			class="p4 bg5 c6 fs3"
			v-if="!results.length && firstSearch && !isLoading"
			>{{ $t("errors.no_file_found") }}</j-card
		>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JSpinner from "@/components/JSpinner"
import CrmIcon from "@/components/CrmIcon/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	name: "SearchFileInput",

	components: { JBaseInputText, JCard, JButton, CrmIcon, JSpinner },

	props: {
		bucketName: String
	},

	data() {
		return {
			isLoading: false,
			searchTerm: "",
			results: [],
			firstSearch: false // Dont display error message if nothing is searched yet
		}
	},

	computed: {
		computedWhere() {
			return {
				keyPattern: this.searchTerm || ""
			}
		}
	},

	methods: {
		selectFile(file) {
			this.$emit("file:found", file)
		},

		async fetchResults() {
			this.results = []
			this.isLoading = true

			const query = gql`
				query searchFiles($bucketName: String, $where: fileWhere) {
					searchFiles(bucketName: $bucketName, where: $where) {
						fileName
						isPublic
						key
						lastModifiedAt
						size
					}
				}
			`

			const res = await api({
				query,
				variables: {
					where: this.computedWhere
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors)
				this.$store.dispatch("showError", [res.errors?.[0]?.message])

			this.results = res?.data?.searchFiles
			if (!this.firstSearch) this.firstSearch = true
		}
	}
}
</script>
